{
  "{text}": "{text}",
  "After {count} question, my best match is {title} at {percent} confidence. | After {count} questions, my best match is {title} at {percent} confidence.": "Après {count} question, ma meilleure piste est {title}, avec {percent} de confiance. | Après {count} questions, ma meilleure piste est {title}, avec {percent} de confiance.",
  "Answer by looking at the pages in front of you. Skipping won't mislead the search, but it still counts as one of your questions.": "Répondez en regardant les pages que vous avez sous les yeux. Passer une question ne faussera pas la recherche, mais elle compte quand même parmi vos questions.",
  "Author or artist name": "Nom de l'auteur ou du dessinateur",
  "Before we start": "Avant de commencer",
  "Best matches": "Meilleures correspondances",
  "Confidence in the leading cover": "Confiance dans la couverture la plus probable",
  "Confidence in the leading story": "Confiance dans l'histoire la plus probable",
  "Currently most likely": "Les plus probables pour l'instant",
  "Data from {source}.": "Données issues de {source}.",
  "Does the cover name who drew it?": "La couverture indique-t-elle qui l'a dessinée ?",
  "Does the first page name who wrote or drew it?": "La première page indique-t-elle qui l'a écrite ou dessinée ?",
  "Don't know": "Je ne sais pas",
  "Don't know (skip reading the title)": "Je ne sais pas (ne pas lire le titre)",
  "First page": "Première page",
  "From the cover alone, my best match is {title} at {percent} confidence.": "D'après la couverture seule, ma meilleure piste est {title}, avec {percent} de confiance.",
  "From the page alone, my best match is {title} at {percent} confidence.": "D'après la page seule, ma meilleure piste est {title}, avec {percent} de confiance.",
  "Got a photo of the story's first page?": "Vous avez une photo de la première page de l'histoire ?",
  "I can't tell": "Je ne saurais pas dire",
  "I think that's it.": "Je crois que c'est celle-là.",
  "Identify another story": "Identifier une autre histoire",
  "If it's a story I've seen before I may recognise it straight away. If not, I'll still use the layout and the title to pick better questions.": "Si je connais déjà cette histoire, je la reconnaîtrai peut-être tout de suite. Sinon, je me servirai quand même de la mise en page et du titre pour choisir de meilleures questions.",
  "If none of these is right, reject them and I'll keep going — the one-page gags are genuinely hard to tell apart.": "Si aucune ne correspond, rejetez-les et je continuerai — les gags en une page sont vraiment difficiles à distinguer.",
  "If none of these is right, reject them and I'll keep going.": "Si aucune ne correspond, rejetez-les et je continuerai.",
  "Language of the magazine": "Langue du magazine",
  "Loading the story index…": "Chargement de l'index des histoires…",
  "Look at the page": "Analyser la page",
  "Look them up on Inducks ↗": "Le chercher sur Inducks ↗",
  "Looking at the page…": "Analyse de la page…",
  "Many printings don't credit anyone — if yours doesn't, skip this. When it is there, it narrows things down more than any question can.": "Beaucoup de publications ne créditent personne — si c'est le cas de la vôtre, passez cette étape. Quand un nom est indiqué, il affine la recherche plus que n'importe quelle question.",
  "Narrowing down {count} covers": "Recherche parmi {count} couvertures",
  "Narrowing down {count} stories": "Recherche parmi {count} histoires",
  "No names printed — start the questions": "Aucun nom indiqué — commencer les questions",
  "No one by that name in Inducks. Check the spelling, or skip.": "Personne de ce nom dans Inducks. Vérifiez l'orthographe, ou passez.",
  "Not sure who that is?": "Vous ne savez pas qui c'est ?",
  "Not this one": "Pas celle-ci",
  "Not {title}": "Pas {title}",
  "Nothing narrowed down yet.": "Rien d'affiné pour l'instant.",
  "Question {index}": "Question {index}",
  "Skip, just ask me questions": "Passer, posez-moi simplement des questions",
  "That's as far as I can narrow it.": "Je ne peux pas affiner davantage.",
  "That's the one": "C'est celle-ci",
  "Try again": "Réessayer",
  "Used to read the story's title off the page, if I don't recognise the image. A title is written in the magazine's language, so I need to know which one to read it in.": "Sert à lire le titre de l'histoire sur la page, si je ne reconnais pas l'image. Le titre est écrit dans la langue du magazine, je dois donc savoir dans quelle langue le lire.",
  "Type a name from the cover…": "Tapez un nom figurant sur la couverture…",
  "Type a name from the page…": "Tapez un nom figurant sur la page…",
  "Untitled cover": "Couverture sans titre",
  "Untitled story": "Histoire sans titre",
  "Which Disney comic story are you reading? Flip through it and answer — no need to know the title.": "Quelle histoire de bande dessinée Disney lisez-vous ? Feuilletez-la et répondez — inutile de connaître le titre.",
  "Your answers ({count})": "Vos réponses ({count})",
  "printed as {name}": "imprimé « {name} »",
  "spread across {count} cover | spread across {count} covers": "répartie sur {count} couverture | répartie sur {count} couvertures",
  "spread across {count} story | spread across {count} stories": "répartie sur {count} histoire | répartie sur {count} histoires",
  "unknown": "inconnue",
  "{count} question | {count} questions": "{count} question | {count} questions",
  "{count} story | {count} stories": "{count} histoire | {count} histoires",
  "{percent} sure of the leading cover": "Sûr à {percent} de la couverture la plus probable",
  "{percent} sure of the leading story": "Sûr à {percent} de l'histoire la plus probable",
  "How long is the story?": "Quelle est la longueur de l'histoire ?",
  "How many rows (tiers) of panels are on a typical page?": "Combien de bandes de cases y a-t-il sur une page type ?",
  "How many panels are in a typical row?": "Combien de cases y a-t-il dans une bande type ?",
  "Roughly how many panels does the story have in total?": "Combien de cases l'histoire compte-t-elle au total, à peu près ?",
  "What decade was the magazine published in?": "Au cours de quelle décennie le magazine a-t-il été publié ?",
  "Whose name is printed on the story's first page?": "Quel nom figure sur la première page de l'histoire ?",
  "Whose name is printed on the cover?": "Quel nom figure sur la couverture ?",
  "Does {name} appear in the story?": "{name} apparaît-il dans l'histoire ?",
  "Does {name} appear on the cover?": "{name} apparaît-il sur la couverture ?",
  "Does the story involve {name}?": "L'histoire fait-elle intervenir « {name} » ?",
  "Does the cover show {name}?": "La couverture montre-t-elle « {name} » ?",
  "Yes": "Oui",
  "No": "Non",
  "{decade}s": "Années {decade}",
  "less than half a page": "moins d'une demi-page",
  "about half a page": "environ une demi-page",
  "1 page": "1 page",
  "1½ pages": "1 page ½",
  "2 pages": "2 pages",
  "2½ pages": "2 pages ½",
  "3 pages": "3 pages",
  "4 pages": "4 pages",
  "5 pages": "5 pages",
  "6 pages": "6 pages",
  "7-8 pages": "7 à 8 pages",
  "9-10 pages": "9 à 10 pages",
  "11-14 pages": "11 à 14 pages",
  "15-20 pages": "15 à 20 pages",
  "21-30 pages": "21 à 30 pages",
  "more than 30 pages": "plus de 30 pages",
  "up to 4": "jusqu'à 4",
  "5-8": "5 à 8",
  "9-12": "9 à 12",
  "13-20": "13 à 20",
  "21-40": "21 à 40",
  "41-80": "41 à 80",
  "more than 80": "plus de 80",
  "6 or more": "6 ou plus",
  "less than {count}": "moins de {count}",
  "more than {count}": "plus de {count}",
  "less than {count} page": "moins de {count} page",
  "less than {count} pages": "moins de {count} pages",
  "more than {count} page": "plus de {count} page",
  "more than {count} pages": "plus de {count} pages",
  "{low}-{high}": "{low} à {high}",
  "{low}-{high} page": "{low} à {high} page",
  "{low}-{high} pages": "{low} à {high} pages"
}
